<template>
    <FormLayout>
        <FormLayoutRow v-if="text">
            <p v-html="$tm(text, '', true)"></p>
        </FormLayoutRow>
        <FormLayoutRow>
            <InputRadio
                v-model="value"
                value="None"
                translationkey="bibhandletype.nonetext"
            />
        </FormLayoutRow>
        <FormLayoutRow>
            <InputRadio
                v-model="value"
                value="MoveAll"
                translationkey="bibhandletype.movealltext"
            />
        </FormLayoutRow>
        <FormLayoutRow>
            <InputRadio
                v-model="value"
                value="KeepChip"
                translationkey="bibhandletype.keepchiptext"
            />
        </FormLayoutRow>
        <FormLayoutRow>
            <InputRadio
                v-model="value"
                value="KeepDevice"
                translationkey="bibhandletype.keepdevicetext"
            />
        </FormLayoutRow>
        <FormLayoutRow>
            <InputRadio
                v-model="value"
                value="KeepAll"
                translationkey="bibhandletype.keepalltext"
            />
        </FormLayoutRow>
    </FormLayout>
</template>
<script lang="ts" setup>
import { InputRadio } from '@/components';
import { FormLayout, FormLayoutRow } from '@/components/Form';
import { type BibHandleType } from '@/objects/generated';

const value = defineModel<BibHandleType>({
    required: true,
});

defineProps<{
    /**
     * Translationkey for the text to display in the header of the form.
     */
    text?: string;
}>();
</script>
